import _isNumber from 'lodash/isNumber';
import _isFinite from 'lodash/isFinite';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
});
const priceFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
const priceFormatToFixed = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const priceFormatRounded = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  maximumFractionDigits: 0,
});

/**
 * Regular expression to insert commas into strings of numbers per US format
 * @example: '1000.00'.replace(/\B(?=(\d{3})+(?!\d))/g, ',') === '1,000.00'
 */
const priceWithCommasRegExp = /\B(?=(\d{3})+(?!\d))/g;

export const numberFormatter = (number) => {
  if (_isNumber(number)) {
    if (number < 0) {
      const integer = Math.trunc(number);
      if (Math.abs(number) - Math.abs(integer) === 0.5) {
        return integer - 1;
      }
    }
    return Math.round(number);
  }
  return 0;
};

export const priceFormatter = (data) => {
  const amount = numberFormatter(data);
  return `${amount >= 0 ? '$' : '-$'}${formatter.format(Math.abs(amount))}`;
};

export const formatNumberToUSD = (data) => {
  return _isFinite(data) ? `${priceFormat.format(data)}` : null;
};

/**
 *
 * @param {number} num
 * @param {number} precision
 * @returns {number}
 * @example: trimDecimalWithoutRounding(71.856, 2) === 71.85
 * @example: trimDecimalWithoutRounding(215.568, 2) === 215.56
 */
export const trimDecimalWithoutRounding = (num, precision) => Number((Math.floor(num * 100) / 100).toFixed(precision));

/**
 *
 * @param {number} data
 * @param {bool} [decorate=false]
 * @returns string
 * @example: priceFormatterWithCommas(1000.00) === '1,000.00'
 * @example: priceFormatterWithCommas(1000.00,) === '1,000.00'
 */
export const priceFormatterWithCommas = (data, decorate = false, wholeDollar = false) => {
  const amount = Number(data);

  if (Number.isNaN(amount)) {
    return '0';
  }

  const decoration = `${amount >= 0 ? '$' : '-$'}`;
  const formatterInUse = wholeDollar ? priceFormatRounded : priceFormatToFixed;

  const formattedNumber = formatterInUse.format(Math.abs(amount)).replace(priceWithCommasRegExp, ',');

  return decorate ? `${decoration}${formattedNumber}` : `${formattedNumber}`;
};

export const percentageCalculator = (data) => {
  const total = data.reduce((partialSum, a) => partialSum + a?.value, 0);
  const percentages = data.map((item) => {
    return { ...item, value: total !== 0 ? (item?.value * 100) / total : 0 };
  });
  return percentages;
};
